import * as React from 'react';
import { Spin, Progress } from 'antd';

export default function Loading({isCircular}) {
  return (
      <>
      {
        isCircular ?  <Spin />
        : <Progress percent={50} status="active" showInfo={false} />
      }
      </>
  );
}